import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MdKeyboardArrowDown } from 'react-icons/md';
import {
  Select,
  Arrow,
  Wrapper,
  BackgroundClick,
  Container,
  Option,
  Label,
  Title,
} from './styles/EnquiryFormSelect.styled';

export default function EnquiryFormSelect({ title, options, dir }) {
  const [toggle, setToggle] = useState(false);
  const [option, setOption] = useState(options[0]);

  const handleClick = (value) => {
    setOption(value);
    setToggle(false);
  };

  return (
    <Wrapper clicked>
      <BackgroundClick toggle={toggle} onClick={() => setToggle(false)} />
      <Title>{title}</Title>
      <Select onClick={() => setToggle(!toggle)} dir={dir}>
        <Label>{option}</Label>
        <Arrow>
          <MdKeyboardArrowDown size="25" />
        </Arrow>
      </Select>
      <Container displayMenu toggle={toggle}>
        {options.map((value) => (
          <Option onClick={() => handleClick(value)} key={value} selected={value === option}>
            {value}
          </Option>
        ))}
      </Container>
    </Wrapper>
  );
}

EnquiryFormSelect.propTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
}.isRequired;
